<div class="dialogContent calcHeight content">
  <irb-settings-dialog-banner [accordian]="accordian" [showUnsavedChangesWarning]="showUnsavedChangesWarning"
    [isModified]="isModified"
    [validationErrorTemplates]="validationErrorTemplates"
    (save)="save()">Trading</irb-settings-dialog-banner>
  <div class="body">
    <mat-accordion #accordian="matAccordion" [multi]="true">
     @if (globalSettings) {
      @if (ENABLE_SETTINGS_HIST) {
        <mat-expansion-panel [expanded]="false" (opened)="iss.updateExpansionState('HISTORY','opened')" (closed)="iss.updateExpansionState('HISTORY','closed')">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Settings History
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <irb-settings-history tabName="Trading"></irb-settings-history>
            </ng-template>
        </mat-expansion-panel>
      }
      <mat-expansion-panel id="ROUNDING_OPTIONS"
        [expanded]="iss.getDefaultExpansionState('ROUNDING_OPTIONS')"
        (opened)="iss.updateExpansionState('ROUNDING_OPTIONS','opened')"
        (closed)="iss.updateExpansionState('ROUNDING_OPTIONS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Rounding
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div style="margin-bottom:5px;">
            You can choose to have each proposed iRebal trade rounded down or up...
            <a calltoaction [calltoactionTemplate]="roundingTemplate">more</a>
          </div>
          <div class="block">
            <span style="margin-right: 10px"><strong>Dollar rounding</strong></span>
              <p-radioButton [disabled]="!isadmin" #isDollarRoundingNo name="dollarRounding" [value]="false"
                             [(ngModel)]="isDollarRounding" (ngModelChange)="onDollarRoundingChange()" inputId="setoritem1"></p-radioButton>
              <label for="setoritem1" [class.p-disabled]="!isadmin">Do not round</label>
              <p-radioButton [disabled]="!isadmin" #isDollarRoundingYes name="dollarRounding" [value]="true"
                             [(ngModel)]="isDollarRounding" (ngModelChange)="onDollarRoundingChange()" inputId="setoritem2"></p-radioButton>
              <label for="setoritem2" [class.p-disabled]="!isadmin">Round to the nearest</label>
            <!--p-dropdown [disabled]="!isadmin" [options]="dollarRoundingDropDown.items" [(ngModel)]="dollarRoundingSetting" *ngIf="dollarRoundingDropDown" (onChange)="onDollarRoundingChange()" optionLabel="name"></p-dropdown-->
            <irb-dropdown-filter #iRbDollarRoundingSettingDD *ngIf="dollarRoundingDropDown"
                                 [disabled]="!isadmin || !isDollarRounding"
                                 [(value)]="dollarRoundingSetting"
                                 (search)="setiRbDollarRoundingSettingDD($event)"
                                 size="20" hoverPanelWidth="180"
                                 (valueChange)="onDollarRoundingChange()"></irb-dropdown-filter>
            <span style="margin: 0 10px">(for mutual funds only)</span>
          </div>
          <div>
            <span style="margin-right: 10px"><strong>Share rounding</strong></span>
              <p-radioButton [disabled]="!isadmin" #isShareRoundingNo name="shareRounding" [value]="false"
                             [(ngModel)]="isShareRounding" (ngModelChange)="onShareRoundingChange()" inputId="setoritem3"></p-radioButton>
              <label for="setoritem3" [class.p-disabled]="!isadmin">Do not round</label>
              <p-radioButton [disabled]="!isadmin" #isShareRoundingYes name="shareRounding" [value]="true"
                             [(ngModel)]="isShareRounding" (ngModelChange)="onShareRoundingChange()" inputId="setoritem4"></p-radioButton>
              <label for="setoritem4" [class.p-disabled]="!isadmin">Round to the nearest</label>
            <!--p-dropdown [disabled]="!isadmin" [options]="shareRoundingDropDown.items" [(ngModel)]="shareRoundingSetting" *ngIf="shareRoundingDropDown" (onChange)="onShareRoundingChange()" optionLabel="name"></p-dropdown-->
            <irb-dropdown-filter #iRbShareRoundingSettingDD *ngIf="shareRoundingDropDown"
                                 [disabled]="!isadmin || !isShareRounding"
                                 [(value)]="shareRoundingSetting"
                                 (search)="setiRbShareRoundingSettingDD($event)"
                                 size="20" hoverPanelWidth="180"
                                 (valueChange)="onShareRoundingChange()"></irb-dropdown-filter>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="VERSUS_PURCHASE_INSTRUCTIONS"
        [expanded]="iss.getDefaultExpansionState('VERSUS_PURCHASE_INSTRUCTIONS')"
        (opened)="iss.updateExpansionState('VERSUS_PURCHASE_INSTRUCTIONS','opened')"
        (closed)="iss.updateExpansionState('VERSUS_PURCHASE_INSTRUCTIONS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Versus Purchase Instructions
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div><strong>Use iRebal tax lot choices (not account default)</strong>
            <span class="infoIcon" style="margin-right: 10px" calltoaction [calltoactionTemplate]="taxLotChoicesTemplate">&nbsp;</span>
              <p-radioButton [disabled]="!isadmin"#sendTaxLotInfoToVEOYes name="sendTaxLotInfoToVEO" [value]="true"
                             [(ngModel)]="globalSettings.sendTaxLotInfoToVEO" (ngModelChange)="onInputChange()" inputId="setoritem5"></p-radioButton>
              <label for="setoritem5" [class.p-disabled]="!isadmin">Yes</label>
              <p-radioButton [disabled]="!isadmin" #sendTaxLotInfoToVEONo name="sendTaxLotInfoToVEO" [value]="false"
                             [(ngModel)]="globalSettings.sendTaxLotInfoToVEO" (ngModelChange)="onInputChange()" inputId="setoritem6"></p-radioButton>
              <label for="setoritem6" [class.p-disabled]="!isadmin">No</label>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="MUTUAL_FUND_RULES"
        [expanded]="iss.getDefaultExpansionState('MUTUAL_FUND_RULES')"
        (opened)="iss.updateExpansionState('MUTUAL_FUND_RULES','opened')"
        (closed)="iss.updateExpansionState('MUTUAL_FUND_RULES','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Mutual Fund Rules
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="block bottomBorder">
            <span class="bold" style="width: 210px; display: inline-block;">Mutual fund transaction fees<span class="infoIcon" style="margin-right: 10px" calltoaction
              [calltoactionTemplate]="manualFundTransactionTemplate">&nbsp;</span>
            </span>
              <p-radioButton [disabled]="!isadmin" #isAddToNetAmountYes name="isAddToNetAmount" [value]="true"
                             [(ngModel)]="globalSettings.isAddToNetAmount" (ngModelChange)="onInputChange()" inputId="setoritem7"></p-radioButton>
              <label for="setoritem7" [class.p-disabled]="!isadmin">Add to net amount</label>
              <p-radioButton [disabled]="!isadmin" #isAddToNetAmountNo name="isAddToNetAmount" [value]="false"
                             [(ngModel)]="globalSettings.isAddToNetAmount" (ngModelChange)="onInputChange()" inputId="setoritem8"></p-radioButton>
              <label for="setoritem8" [class.p-disabled]="!isadmin">Include in net amount</label>
          </div>
          <div>
              <span class="bold" style="width: 210px; display: inline-block;">Mutual fund sell amount type<span class="infoIcon" style="margin-right: 10px" calltoaction
                [calltoactionTemplate]="manualFundSellAmountTemplate">&nbsp;</span>
              </span>
              <p-radioButton #isMfSellAmtTypeDollarsTrue name="isMfSellAmtTypeDollars" [value]="true"
                             [(ngModel)]="globalSettings.isMfSellAmtTypeDollars" (ngModelChange)="onInputChange()"
                             [disabled]="!isadmin || globalSettings.avoidRedemptionPenalty" inputId="setoritem9"></p-radioButton>
              <label for="setoritem9" [class.p-disabled]="!isadmin || globalSettings.avoidRedemptionPenalty">Dollars</label>
              <p-radioButton [disabled]="!isadmin" #isMfSellAmtTypeDollarsFalse name="isMfSellAmtTypeDollars" [value]="false"
                             [(ngModel)]="globalSettings.isMfSellAmtTypeDollars" (ngModelChange)="onInputChange()" inputId="setoritem10"></p-radioButton>
              <label for="setoritem10" [class.p-disabled]="!isadmin">Shares</label>
          </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="ORDER_TYPE_DEFAULTS"
        [expanded]="iss.getDefaultExpansionState('ORDER_TYPE_DEFAULTS')"
        (opened)="iss.updateExpansionState('ORDER_TYPE_DEFAULTS','opened')"
        (closed)="iss.updateExpansionState('ORDER_TYPE_DEFAULTS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Order Type Defaults
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="block bottomBorder">
            <div style="margin-bottom:5px;">
              You can have iRebal generate equity or option orders with the order type default set to either market or limit...
              <a calltoaction [calltoactionTemplate]="orderTypeDefaultsTemplate">more</a>
            </div>
            <div class="left bold" style="width: 60px; line-height: 26px;">Equity</div>
            <div class="left">
              <div class="block">
                <div class="left" style="margin-right: 10px; line-height: 26px; width: 95px;"><span class="bold">Sell</span> Order type:</div>
                <div class="left" style="margin-right: 10px; line-height: 26px;">
                    <p-radioButton [disabled]="!isadmin" #isEquitySellOrderTypeMarketYes name="equitySellOrderType" [value]="'Market'"
                                   [(ngModel)]="equitySellActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem11"></p-radioButton>
                    <label for="setoritem11" [class.p-disabled]="!isadmin">Market</label>
                    <p-radioButton [disabled]="!isadmin" #isEquitySellOrderTypeMarketNo name="equitySellOrderType" [value]="'Limit'"
                                   [(ngModel)]="equitySellActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem12"></p-radioButton>
                    <label for="setoritem12" [class.p-disabled]="!isadmin">Limit</label>
                </div>
                <div class="left">
                  <!--p-dropdown [disabled]="!isadmin" *ngIf="!equitySellOrderTypeDefault || equitySellActionTypeDefault.defaultOrderType == 'Market'" [options]="[{name: 'M'}]" [disabled]="true" optionLabel="name"></p-dropdown-->
                  <!--p-dropdown [disabled]="!isadmin" *ngIf="equitySellOrderTypeDefault && equitySellActionTypeDefault.defaultOrderType == 'Limit'" [options]="priceTypeDropDown.items"  optionLabel="name" [(ngModel)]="equitySellOrderTypeDefault" (onChange)="onOrderTypeDefaultsChange()"></p-dropdown-->

                  <irb-dropdown-filter
                          *ngIf="!equitySellOrderTypeDefault || equitySellActionTypeDefault.defaultOrderType == 'Market'"
                          [disabled]="true"
                          [value]="{name: 'M', value: 'M'}"
                          size="20" hoverPanelWidth="180"></irb-dropdown-filter>
                  <irb-dropdown-filter #iRbEquitySellDD
                                       *ngIf="equitySellOrderTypeDefault && equitySellActionTypeDefault.defaultOrderType == 'Limit'"
                                       [disabled]="!isadmin"
                                       [(value)]="equitySellOrderTypeDefault"
                                       (search)="setiRbEquitySellDD($event)"
                                       size="20" hoverPanelWidth="180"
                                       (valueChange)="onOrderTypeDefaultsChange()"></irb-dropdown-filter>

                </div>
                <span *ngIf="equitySellActionTypeDefault.defaultOrderType && equitySellOrderTypeDefault" class="order-type-note" style="margin-left: 10px">
                  <strong>Limit price</strong> will be set to the latest <strong>{{equitySellOrderTypeDefault.name}}</strong> value at the time of submission
                </span>
                <br class="clear"/>
              </div>

              <div>
                <div class="left" style="margin-right: 10px; line-height: 26px; width: 95px;"><span class="bold">Buy</span> Order type:</div>
                <div class="left" style="margin-right: 10px; line-height: 26px;">
                    <p-radioButton [disabled]="!isadmin" #isEquityBuyOrderTypeMarketYes name="equityBuyOrderType" [value]="'Market'"
                                   [(ngModel)]="equityBuyActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem13"></p-radioButton>
                    <label for="setoritem13" [class.p-disabled]="!isadmin">Market</label>
                    <p-radioButton [disabled]="!isadmin" #isEquityBuyOrderTypeMarketNo name="equityBuyOrderType" [value]="'Limit'"
                                   [(ngModel)]="equityBuyActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem14"></p-radioButton>
                    <label for="setoritem14" [class.p-disabled]="!isadmin">Limit</label>
                </div>
                <div class="left">
                  <!--p-dropdown-- [disabled]="!isadmin" *ngIf="!equityBuyOrderTypeDefault || equityBuyActionTypeDefault.defaultOrderType == 'Market'" [options]="[{name: 'M'}]" [disabled]="true" optionLabel="name"></p-dropdown-->
                  <!--p-dropdown [disabled]="!isadmin" *ngIf="equityBuyOrderTypeDefault && equityBuyActionTypeDefault.defaultOrderType == 'Limit'" [options]="priceTypeDropDown.items"  optionLabel="name" [(ngModel)]="equityBuyOrderTypeDefault" (onChange)="onOrderTypeDefaultsChange()"></p-dropdown-->

                  <irb-dropdown-filter
                          *ngIf="!equityBuyOrderTypeDefault || equityBuyActionTypeDefault.defaultOrderType == 'Market'"
                          [disabled]="true"
                          [value]="{name: 'M', value: 'M'}"
                          size="20" hoverPanelWidth="180"></irb-dropdown-filter>
                  <irb-dropdown-filter #iRbEquityBuyDD
                                       *ngIf="equityBuyOrderTypeDefault && equityBuyActionTypeDefault.defaultOrderType == 'Limit'"
                                       [disabled]="!isadmin"
                                       [(value)]="equityBuyOrderTypeDefault"
                                       (search)="setiRbEquityBuyDD($event)"
                                       size="20" hoverPanelWidth="180"
                                       (valueChange)="onOrderTypeDefaultsChange()"></irb-dropdown-filter>
                </div>
                <span *ngIf="equityBuyActionTypeDefault.defaultOrderType && equityBuyOrderTypeDefault" class="order-type-note" style="margin-left: 10px">
                  <strong>Limit price</strong> will be set to the latest <strong>{{equityBuyOrderTypeDefault.name}}</strong> value at the time of submission
                </span>
                <br class="clear"/>
              </div>
            </div>
            <br class="clear"/>
          </div>

          <div class="block">
              <div class="left bold" style="width: 60px; line-height: 26px;">Options</div>
              <div class="left">
                <div class="block">
                  <div class="left" style="margin-right: 10px; line-height: 26px; width: 95px;"><span class="bold">Sell</span> Order type:</div>
                  <div class="left" style="margin-right: 10px; line-height: 26px;">
                      <p-radioButton [disabled]="!isadmin" #isOptionsSellOrderTypeMarketYes name="optionsSellOrderType" [value]="'Market'"
                                     [(ngModel)]="optionsSellActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem15"></p-radioButton>
                      <label for="setoritem15" [class.p-disabled]="!isadmin">Market</label>
                      <p-radioButton [disabled]="!isadmin" #isOptionsSellOrderTypeMarketNo name="optionsSellOrderType" [value]="'Limit'"
                                     [(ngModel)]="optionsSellActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem16"></p-radioButton>
                      <label for="setoritem16" [class.p-disabled]="!isadmin">Limit</label>
                  </div>
                  <div class="left">
                    <!--p-dropdown [disabled]="!isadmin" *ngIf="!optionsSellOrderTypeDefault || optionsSellActionTypeDefault.defaultOrderType == 'Market'" [options]="[{name: 'M'}]" [disabled]="true" optionLabel="name"></p-dropdown>
                    <p-dropdown-- [disabled]="!isadmin" *ngIf="optionsSellOrderTypeDefault && optionsSellActionTypeDefault.defaultOrderType == 'Limit'" [options]="priceTypeDropDown.items"  optionLabel="name" [(ngModel)]="optionsSellOrderTypeDefault" (onChange)="onOrderTypeDefaultsChange()"></p-dropdown-->

                    <irb-dropdown-filter
                            *ngIf="!optionsSellOrderTypeDefault || optionsSellActionTypeDefault.defaultOrderType == 'Market'"
                            [disabled]="true"
                            [value]="{name: 'M', value: 'M'}"
                            size="20" hoverPanelWidth="180"></irb-dropdown-filter>
                    <irb-dropdown-filter #iRbOptionSellDD
                                         *ngIf="optionsSellOrderTypeDefault && optionsSellActionTypeDefault.defaultOrderType == 'Limit'"
                                         [disabled]="!isadmin"
                                         [(value)]="optionsSellOrderTypeDefault"
                                         (search)="setiRbOptionSellDD($event)"
                                         size="20" hoverPanelWidth="180"
                                         (valueChange)="onOrderTypeDefaultsChange()"></irb-dropdown-filter>
                  </div>
                  <span *ngIf="optionsSellActionTypeDefault.defaultOrderType && optionsSellOrderTypeDefault" class="order-type-note" style="margin-left: 10px">
                    <strong>Limit price</strong> will be set to the latest <strong>{{optionsSellOrderTypeDefault.name}}</strong> value at the time of submission
                  </span>
                  <br class="clear"/>
                </div>

                <div>
                  <div class="left" style="margin-right: 10px; line-height: 26px; width: 95px;"><span class="bold">Buy</span> Order type:</div>
                  <div class="left" style="margin-right: 10px; line-height: 26px;">
                      <p-radioButton [disabled]="!isadmin" #isOptionsBuyOrderTypeMarketYes name="optionsBuyOrderType" [value]="'Market'"
                                     [(ngModel)]="optionsBuyActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem17"></p-radioButton>
                      <label for="setoritem17" [class.p-disabled]="!isadmin">Market</label>
                      <p-radioButton [disabled]="!isadmin" #isOptionsBuyOrderTypeMarketNo name="optionsBuyOrderType" [value]="'Limit'"
                                     [(ngModel)]="optionsBuyActionTypeDefault.defaultOrderType" (ngModelChange)="onOrderTypeDefaultsChange()" inputId="setoritem18"></p-radioButton>
                      <label for="setoritem18" [class.p-disabled]="!isadmin">Limit</label>
                  </div>
                  <div class="left">
                    <!--p-dropdown [disabled]="!isadmin" *ngIf="!optionsBuyOrderTypeDefault || optionsBuyActionTypeDefault.defaultOrderType == 'Market'" [options]="[{name: 'M'}]" [disabled]="true" optionLabel="name"></p-dropdown>
                    <p-dropdown [disabled]="!isadmin" *ngIf="optionsBuyOrderTypeDefault && optionsBuyActionTypeDefault.defaultOrderType == 'Limit'" [options]="priceTypeDropDown.items"  optionLabel="name" [(ngModel)]="optionsBuyOrderTypeDefault" (onChange)="onOrderTypeDefaultsChange()"></p-dropdown-->

                    <irb-dropdown-filter
                            *ngIf="!optionsBuyOrderTypeDefault || optionsBuyActionTypeDefault.defaultOrderType == 'Market'"
                            [disabled]="true"
                            [value]="{name: 'M', value: 'M'}"
                            size="20" hoverPanelWidth="180"></irb-dropdown-filter>
                    <irb-dropdown-filter #iRbOptionBuyDD
                                         *ngIf="optionsBuyOrderTypeDefault && optionsBuyActionTypeDefault.defaultOrderType == 'Limit'"
                                         [disabled]="!isadmin"
                                         [(value)]="optionsBuyOrderTypeDefault"
                                         (search)="setiRbOptionBuyDD($event)"
                                         size="20" hoverPanelWidth="180"
                                         (valueChange)="onOrderTypeDefaultsChange()"></irb-dropdown-filter>
                  </div>
                  <span *ngIf="optionsBuyActionTypeDefault.defaultOrderType && optionsBuyOrderTypeDefault" class="order-type-note" style="margin-left: 10px">
                    <strong>Limit price</strong> will be set to the latest <strong>{{optionsBuyOrderTypeDefault.name}}</strong> value at the time of submission
                  </span>
                  <br class="clear"/>
            </div>
          </div>
          <br class="clear"/>
        </div>
        </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel id="ORDER_AUTHORIZATIONS"
        [expanded]="iss.getDefaultExpansionState('ORDER_AUTHORIZATIONS')"
        (opened)="iss.updateExpansionState('ORDER_AUTHORIZATIONS','opened')"
        (closed)="iss.updateExpansionState('ORDER_AUTHORIZATIONS','closed')">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Order Authorizations
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div>
            <span style="margin-right: 10px"><strong>Select default order authorization</strong></span>
            <span style="margin-right: 10px">
                <p-checkbox [disabled]="!isadmin" #isSolicited name="isSolicited" [(ngModel)]="globalSettings.isSolicited" binary="true" (onChange)="onInputChange();" inputId="setoritem19"></p-checkbox>
                <label for="setoritem19" [class.p-disabled]="!isadmin">Solicited</label>
            </span>
              <p-checkbox [disabled]="!isadmin" #isDiscretionary name="isDiscretionary" [(ngModel)]="globalSettings.isDiscretionary" binary="true" (onChange)="onInputChange();" inputId="setoritem20"></p-checkbox>
              <label for="setoritem20" [class.p-disabled]="!isadmin">Discretionary</label>
            <div>
              The designations will not appear on the Client's trade confirmation and the notation on the platform is for advisor audit purposes only.
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
     }
    </mat-accordion>
  </div>
</div>
<ng-template #roundingTemplate>
  <div class="block">You can choose to have each proposed iRebal trade rounded down or up. For example, if 43 shares are proposed and the rounding is set to 10, the proposed order would be rounded down to 40.</div>
  <div>Note: Min buys/sell settings and available cash will also be taken into account in determining how to round up or down.</div>
</ng-template>
<ng-template #taxLotChoicesTemplate>
  <div class="block">Note: VSP instructions will not be sent for:</div>
  <div class="block">1) Mutual fund sales done in dollars. If you want iRebal to send VSP instructions for these trades, you must edit the sale on the Order Blotter so it is sent in shares.</div>
  <div class="block">2) Mutual fund sales done in average cost accounts. The tax lot relief method for average cost lots must be first-in, first-out (FIFO) and cannot be changed to any other type. Thus, the estimated gains and losses displayed by iRebal may not match those realized when trades are executed.</div>
  <div>3) Any type of Option orders.</div>
</ng-template>
<ng-template #manualFundTransactionTemplate>
  Note: For Mutual Fund sales done in shares, iRebal will always send instructions to include fees in the net amount of the trade.
</ng-template>
<ng-template #manualFundSellAmountTemplate>
  <div class="block">This setting controls the form in which a mutual fund trade is sent to Schwab Advisor Center for execution.</div>
  <div>Note: Versus purchase instructions will not be sent for mutual fund sales done in dollars. If you want iRebal to send VSP instructions for mutual fund sales, your mutual fund sales must be done in shares.</div>
</ng-template>
<ng-template #orderTypeDefaultsTemplate>
  <div class="block">You can have iRebal generate equity or option orders with the order type default set to either market or limit on the Order Blotter. If the order type default is set to limit, a limit price must also be specified. The limit price options available are the last trade, bid, ask, or midpoint between the bid and ask values at the time of submission.</div>
  <div>Note: These limit price options are not static values, and iRebal will set the actual Limit Price amount to the latest value at the time of submission.</div>
</ng-template>
